if (!customElements.get("variant-dependent")) {
  class VariantDependent extends HTMLElement {
    constructor() {
      super();
      this.productUrl = this.dataset.productUrl;
      this.sectionId = this.dataset.sectionId;
    }
    connectedCallback() {
      if (!this.productUrl || !this.sectionId) return;
      document.addEventListener(
        "variant:changed",
        this.onVariantChanged.bind(this)
      );
    }
    onVariantChanged = (event) => {
      const variant = event.detail.variant;
      if (variant) {
        const url =
          this.productUrl + "?variant=" + variant.id + "&" + this.sectionId;
        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const newContent = html.querySelector("variant-dependent");
            if (newContent && newContent.innerHTML.trim().length) {
              this.innerHTML = newContent.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };
  }
  customElements.define("variant-dependent", VariantDependent);
}
